<template>
    <div v-if="contentArea" class="d-inline">
        <i class="bi-chevron-compact-right mx-1 align-middle"/>

        <Button @mouseover.native="onMouseover" @mouseout.native="onMouseout" @click.native="selectContentArea"
                class="btn-sm lh-1 p-1">
            <small>{{ contentArea.label }}</small>
        </Button>
    </div>
</template>

<script>
import Button from "../../common/Button.vue"

export default {
    name: "PageEditorToolbarContentAreaBtn",
    components: {Button},
    computed: {
        pageEditor() {
            return this.$store.state.pageEditor
        },
        pageId() {
            return this.pageEditor.pageId
        },
        activePageContentId() {
            return this.pageEditor.activePageContentId
        },
        activeContent() {
            return this.pageEditor.contentItems.find(o => o.pageContentId === this.activePageContentId)
        },
        contentAreaName() {
            return this.pageEditor.activeContentAreaName || this.activeContent?.contentAreaName
        },
        contentArea() {
            return this.pageEditor.contentAreas.find(o => o.name === this.contentAreaName)
        }
    },
    methods: {
        onMouseover() {
            this.$store.commit('pageEditor/hoverContentAreaName', this.contentAreaName)
        },
        onMouseout() {
            this.$store.commit('pageEditor/hoverContentAreaName', '')
        },
        async selectContentArea() {
            await this.$store.dispatch('pageEditor/goToContentArea', {
                router: this.$router,
                contentAreaName: this.contentAreaName
            })

            this.$store.commit('pageEditor/leftSidebarActiveTab', 'Content')

            await this.$store.dispatch('pageEditor/scrollToContentArea', {
                contentAreaName: this.contentAreaName
            })
        }
    }
}
</script>

<style scoped>

</style>